/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "3b7b6ef26eed76f3a1c2594f8c014825efb08dd3";
